import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import TextBubble from '../ui-components/TextBubble'
import BottomSheetContent from './BottomSheetContent'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const BODY_CLASS = "text-[#6a6e6e] text-sm font-normal font-['Matter'] leading-[90%]"
const EMPHASIS_CLASS = "text-[#232323] text-sm font-medium font-['Matter'] leading-[90%]"

export const TRLearnMoreBottomSheet = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: 'Trailing_Returns_Performance_See_WHY',
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent onDismiss={onDismiss}>
      <TextBubble text='This metric only compares point to point returns, and may not capture how consistent the fund is over time.' />
      <div className='pt-4 pb-1 flex flex-col gap-4'>
        <HelpDialogPassage accessibleLabel="It is calculated by considering the fund's value on just 2 days; the start and end date. Hence, any rise and fall in between gets overlooked.">
          <span className={BODY_CLASS}>
            It is calculated by considering the fund’s value on just 2 days; the start and end date. Hence,{' '}
          </span>
          <span className={EMPHASIS_CLASS}>any rise and fall in between gets overlooked.</span>
        </HelpDialogPassage>
        <HelpDialogPassage accessibleLabel='It also has a bias towards recent performance. If the market is doing well recently, the fund might show high returns, concealing any past losses.'>
          <span className={BODY_CLASS}>
            It also has a bias towards recent performance. If the market is doing well recently, the fund might show
            high returns, concealing any past losses.
          </span>
        </HelpDialogPassage>
        <HelpDialogPassage accessibleLabel="Tip: A better metric to track a mutual fund's long term performance is rolling returns, as it accounts for consistency in returns over a period of time.">
          <span className={BODY_CLASS}>
            Tip: A better metric to track a mutual fund’s long term performance is rolling returns, as it accounts for
            consistency in returns over a period of time.
          </span>
        </HelpDialogPassage>
      </div>
    </BottomSheetContent>
  )
}
